import React, { Component } from 'react';

const Context = React.createContext({
  values: {},
  errors: {},
  getError: () => null,
  setErrors: () => null,
  getContext: () => null,
  getValue: name => null,
  getValues: getValues => {},
  onChange: (name, value) => null
});

class ValuesProvider extends Component {
  constructor (props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.getError = this.getError.bind(this);
    this.getValues = this.getValues.bind(this);
    this.setErrors = this.setErrors.bind(this);
    this.getContext = this.getContext.bind(this);
    this.clearError = this.clearError.bind(this);

    this.state = {
      errors: this.props.errors,
      values: this.props.values,

      getValue: this.getValue,
      getValues: this.getValues,
      onChange: this.onChange,

      getError: this.getError,
      setErrors: this.setErrors,
      getContext: this.getContext
    };
  }

  getContext () {
    return this.state;
  }

  onChange (name, value) {
    if (this.getError(name)) {
      this.clearError(name);
    }

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [name]: value
      }
    }));
  }

  clearError (name) {
    this.setState(state => ({
      ...state,
      errors: {
        ...state.errors,
        [name]: undefined
      }
    }));
  }

  getValue (name) {
    return this.values[name] || '';
  }

  getError (name) {
    return this.errors[name] || '';
  }

  setErrors (errors) {
    this.setState(state => ({
      ...state,
      errors: errors
    }));
  }

  getValues () {
    return this.values;
  }

  get errors () {
    return this.state.errors;
  }

  get values () {
    return this.state.values;
  }

  render () {
    return (
      <Context.Provider value={this.state}>
        {this.props.children}
      </Context.Provider>
    );
  }
}

ValuesProvider.defaultProps = {
  values: {},
  errors: {}
};

export const context = Context;
export default ValuesProvider;
